/**
 * ArticleCard - blog article preview card used in grids and carousels.
 * Custom element: <article-card>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class ArticleCard extends ThemeComponent {}
setFunctionName(ArticleCard, "ArticleCard");
const propertyTypes = {};
ArticleCard.prototype.$name = "ArticleCard";
ArticleCard.prototype.$info = JSON.parse('{"name":"ArticleCard","meta":{"isLegacy":false,"selector":"article-card"},"props":[],"refs":[]}');
ArticleCard.prototype.$info.component = ArticleCard;
for (const prop of ArticleCard.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Article/ArticleCard.ts", {
  ArticleCard: ArticleCard
}, void 0);